import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function Hero() {
  return <header className="bg-navy px-3 pb-4 pt-3 text-center sm:px-6 sm:pb-5 sm:pt-4" data-id="element-75" data-mp="eiv62y7sfcld">
      <h1 className="text-[1.3rem] font-extrabold uppercase leading-[1.08] text-white sm:text-[2.2rem]" data-id="element-76" data-mp="9k0ep7vr8fpn">
        The Complete Visual Study System for{' '}
        <span className="text-teal-light" data-id="element-77" data-mp="4jm7fs1z99so">Cardiology Students</span>
      </h1>
      <p className="mx-auto mt-1.5 max-w-xl text-[0.78rem] leading-[1.35] text-white/85 sm:text-[0.92rem]" data-id="element-78" data-mp="128yzydv6bxz6">
        Stop jumping between textbooks, lecture notes, ECG references and scattered cardiology
        resources every time you need to understand what you're seeing. Use organized visual
        references, annotated ECGs, cardiac imaging comparisons, rhythm guides and
        pattern-recognition tools to understand cardiology concepts and recognize important findings
        more clearly.
      </p>
      <p className="mt-1 font-heading text-[0.74rem] font-extrabold uppercase leading-tight tracking-wide text-teal-light sm:text-sm" data-id="element-79" data-mp="384jssxvrzhse">
        Interpret. Compare. Recognize with confidence.
      </p>

      <BoxImage className="mx-auto mt-2 max-w-[260px] sm:max-w-[340px]" data-id="element-80" data-mp="3o5j41cky9nmv" />

      <div className="mx-auto mt-2 max-w-md" data-id="element-81" data-mp="399jq3lb5st9t">
        <CTAButton label="❤️ YES! I WANT THE COMPLETE SYSTEM" data-id="element-82" data-mp="3e9fqzbok84l5" />
        <p className="mt-1.5 font-heading text-[0.66rem] font-extrabold uppercase tracking-[0.1em] text-white sm:text-xs" data-id="element-83" data-mp="3e7l5nw9dmagj">
          GET CARDIOLOGY VISUAL ATLAS™ TODAY
        </p>
        <p className="mt-1 text-[0.62rem] font-bold uppercase tracking-wide text-white/75 sm:text-xs" data-id="element-84" data-mp="359jahxcbqc16">
          🛡️ 7-Day Money-Back Guarantee <span className="text-teal-light" data-id="element-85" data-mp="2qhqwpps6h61k">•</span> ⚡ COMPLETE 6-IN-1
          SYSTEM
        </p>
      </div>
    </header>;
}